import { AsyncThunk } from '@reduxjs/toolkit';
import { ActionReducerMapBuilder } from '@reduxjs/toolkit/dist/mapBuilders';
import {
  EditRequest,
  PageState,
  allResourceNames,
  Resource,
} from 'store/types';
import { each } from 'lodash-es';

export default (
  builder: ActionReducerMapBuilder<PageState>,
  editRequest: AsyncThunk<
    Resource,
    EditRequest,
    {
      rejectValue: boolean;
    }
  >
) => {
  builder.addCase(editRequest.pending, (state) => {
    state.result = null;
  });
  builder.addCase(editRequest.fulfilled, (state, { payload }) => {
    each(allResourceNames, (name) => {
      const item = state?.resources?.[name]?.data?.[payload._id];

      if (item) {
        item.tags = payload.tags;
      }
    });

    // Не забываем про текущую карточку
    if (state.lastFetchedItem?._id === payload._id) {
      state.lastFetchedItem.tags = payload.tags;
    }

    state.result = {
      type: 'success',
      message: 'Теги успешно изменены',
    };
  });
  builder.addCase(editRequest.rejected, (state) => {
    state.result = {
      type: 'error',
      message: 'Упс, кажется что то пошло не так',
    };
  });
};
